import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20lottery%20theme%20with%20floating%20golden%20numbers%20and%20spheres%20on%20deep%20warm%20background%2C%20dramatic%20lighting%20with%20amber%20and%20gold%20gradients%2C%20luxurious%20and%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20cinematic%20composition%20with%20bokeh%20effects%2C%20premium%20feel%20with%20dark%20and%20gold%20contrast&width=1600&height=800&seq=hero-lottery-main&orientation=landscape"
        alt="六合彩指南 - 精选推荐与玩法指南"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 text-center px-4 w-full max-w-[900px] mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-shield-check-line text-accent-400 text-sm"></i>
          </div>
          <span className="text-sm text-background-50/90">权威六合彩资讯平台</span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight">
          六合彩网站精选推荐
          <br />
          <span className="text-primary-400">与玩法指南</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/75 max-w-[700px] mx-auto mb-8 leading-relaxed">
          汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧。无论您是新手还是老玩家，都能在此找到可靠的六合彩使用指南。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/wanfa-guize"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md font-medium text-sm transition-all whitespace-nowrap w-full sm:w-auto text-center"
          >
            开始了解玩法规则
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/kaijiang-zixun"
            className="px-6 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-md font-medium text-sm transition-all whitespace-nowrap w-full sm:w-auto text-center"
          >
            查看最新开奖
            <i className="ri-bar-chart-line ml-2"></i>
          </Link>
        </div>
        <div className="flex items-center justify-center gap-6 mt-10 text-background-50/60 text-sm">
          <div className="flex items-center gap-1.5">
            <i className="ri-article-line"></i>
            <span>50+ 精选文章</span>
          </div>
          <div className="w-px h-4 bg-background-50/20"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-group-line"></i>
            <span>10万+ 月活用户</span>
          </div>
          <div className="w-px h-4 bg-background-50/20"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-timer-line"></i>
            <span>实时更新</span>
          </div>
        </div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}